import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50df4477")

_pushScopeId("data-v-50df4477")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Programma lavoro")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = {
  key: 0,
  class: "modal_appuntamenti_passati"
}
const _hoisted_5 = { class: "appuntamenti_passati_container" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "modal_appuntamenti_title" }, "Appuntamenti passati senza rapportino", -1)
const _hoisted_7 = { class: "container_no_app" }
const _hoisted_8 = { class: "cliente_info" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "address" }
const _hoisted_11 = { class: "address" }
const _hoisted_12 = { class: "container_appuntamenti" }
const _hoisted_13 = { class: "container_selected_day" }
const _hoisted_14 = { class: "selected_day" }
const _hoisted_15 = {
  key: 0,
  class: "no_appuntamenti_container"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "no_appuntamenti" }, "Nessun appuntamento da visualizzare", -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "cliente_info" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "address" }
const _hoisted_21 = { class: "address" }
const _hoisted_22 = {
  key: 0,
  class: "rapportino_creato"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadAppuntamenti()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading || $setup.loadingAppuntamentiPassati)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_Transition, { name: "fade-transition" }, {
                  default: _withId(() => [
                    ($setup.showAppuntamentiPassati)
                      ? (_openBlock(), _createBlock("div", _hoisted_4, [
                          _createVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createVNode("div", _hoisted_7, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.appuntamentiSenzaRapportino, (app, index) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: index,
                                  class: "appuntamento appuntamento_no_rapportino",
                                  onClick: ($event: any) => ($setup.openDetailModal(app))
                                }, [
                                  _createVNode("div", _hoisted_8, [
                                    _createVNode("div", _hoisted_9, _toDisplayString(app.projects_name), 1),
                                    _createVNode("div", _hoisted_10, _toDisplayString($setup.riferimentoCliente(app)), 1),
                                    _createVNode("div", _hoisted_11, _toDisplayString($setup.dateFormat(app.appuntamenti_giorno)) + ", " + _toDisplayString(`${app.appuntamenti_ora_inizio} -  ${app.appuntamenti_ora_fine}`), 1)
                                  ])
                                ], 8, ["onClick"]))
                              }), 128))
                            ]),
                            _createVNode("div", {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showAppuntamentiPassati = false)),
                              class: "btn_chiudi"
                            }, "chiudi")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_Calendar, {
                    value: $setup.date,
                    "is-expanded": "",
                    attributes: $setup.setAttributes,
                    onDayclick: $setup.dayClicked,
                    "onUpdate:fromPage": $setup.loadCurrentMonthData,
                    class: "calendar_container",
                    ref: "calendarRef"
                  }, null, 8, ["value", "attributes", "onDayclick", "onUpdate:fromPage"]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, _toDisplayString($setup.selectedDay.id ? $setup.dateFormat($setup.selectedDay.id) : $setup.dateFormat($setup.date)), 1),
                    (!$setup.appuntamentiToShow.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, [
                          _hoisted_16
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_17, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.appuntamentiToShow, (appuntamento) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "appuntamento",
                              key: appuntamento.customers_id,
                              onClick: ($event: any) => ($setup.openDetailModal(appuntamento))
                            }, [
                              _createVNode("div", _hoisted_18, [
                                _createVNode("div", _hoisted_19, _toDisplayString(appuntamento.projects_name), 1),
                                _createVNode("div", _hoisted_20, _toDisplayString($setup.riferimentoCliente(appuntamento)), 1),
                                _createVNode("div", _hoisted_21, "Orario: " + _toDisplayString(`${appuntamento.appuntamenti_ora_inizio} -  ${appuntamento.appuntamenti_ora_fine}`), 1),
                                (appuntamento.rapportino_creato)
                                  ? (_openBlock(), _createBlock("div", _hoisted_22, " Rapportino creato "))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode("div", null, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: ['fas', $setup.setIcon(appuntamento)],
                                  style: {"color":"#086fa3","font-size":"20px"}
                                }, null, 8, ["icon"])
                              ])
                            ], 8, ["onClick"]))
                          }), 128))
                        ]))
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})